
import Vue, { PropType } from "vue";
import { DcmMetadata, DcmMetadataForm } from "../interfaces/DcmMetadataConfig";
import { MetadataField } from "../services/properties";

export default Vue.extend({
  props: {
    fields: {
      type: Array as PropType<MetadataField[]>,
      required: true,
    },
    item: {
      type: Object as PropType<DcmMetadata>,
      required: true,
    },
    value: {
      type: Object as PropType<DcmMetadataForm>,
      required: true,
    },
  },
  data() {
    return {
      hasToForceDateEmit: false,
      valid: true,
    };
  },
  created() {
    this.bindFields();
  },
  updated() {
    this.$emit("update:valid", this.valid);
  },
  methods: {
    // e.g.: bindFields(true) is launched by switchToUpdateMode in ViewOrEditDcmProperties.vue
    bindFields(isUpdateMode = false) {
      if (this.fields) {
        if (isUpdateMode) {
          this.$emit("set-update-mode");
        }
        for (const field of this.fields) {
          const key = field.alias ? `${field.alias}.${field.metadataName}` : field.metadataName;
          this.$set(
            this.value,
            field.metadataName,
            field.formatOnLoad ? field.formatOnLoad(this.item[key] as any) : this.item[key]
          );
        }
        this.hasToForceDateEmit = isUpdateMode;
        if (isUpdateMode) {
          this.$nextTick(() => {
            this.$emit("set-comparison-data", JSON.parse(JSON.stringify(this.value)));
          });
        }
      } else {
        this.$emit("error");
      }
    },
  },
});
